import * as S from './Select.styled';

export default S.Select;
